export enum EProductWithCountsSort {
  DEFAULT = "לפי ברירת מחדל",
  PRODUCT = "לפי פריט",
}